// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"180":"App","957":"views-app"}[chunkId] || chunkId) + "." + {"180":"d3f11227","527":"1c7a601c","887":"d3324df9","957":"1b69c4db"}[chunkId] + ".chunk.css";
};